import { createAuthClient } from "better-auth/react";

/**
 * Same origin as the app, so no baseURL is needed. The Worker mounts Better
 * Auth at /api/auth.
 */
export const authClient = createAuthClient({ basePath: "/api/auth" });

export const { signIn, signUp, signOut, useSession } = authClient;
